import ValueParser from "./ValueParser";

export default {
    parse(object, data) {
        Object.entries(object || {}).forEach(props => {
            let [name, value] = props;
            object[name] = ValueParser.parse(value, data);
        });

        return object;
    }
}


// WEBPACK FOOTER //
// ./src/services/parser/ObjectParser.js